import React, { useState, useEffect } from 'react'
import { NavLink, useParams } from 'react-router-dom'
import axios from 'axios'

function ActivationEmail() {
    const { activation_token } = useParams()
    const [err, setErr] = useState('')
    const [success, setSuccess] = useState('')

    useEffect(() => {
        if (activation_token) {
            const activationEmail = async () => {
                try {
                    const res = await axios.post('/user/activation', { activation_token })

                    setSuccess(res.data.msg)
                } catch (err) {
                    err.response.data.msg && setErr(err.response.data.msg)
                }
            }
            activationEmail()
        }
    }, [activation_token])

    return (
        <div className="container">
            {err && <h2>Что-то пошло не так...</h2>}

            {success &&
                <div>
                    <h2>Активация прошла успешно</h2>
                    <p>теперь вы можете войти в личный кабинет:</p>

                    <NavLink to='/'>Вход</NavLink>
                </div>
            }
        </div>
    )
}

export default ActivationEmail
